import 'core-js/stable/object';
export const getEntries = (record) => Object.entries(record);
export const mapRecord = (record, callback) => {
    const entries = getEntries(record).map(([key, value]) => callback(key, value));
    const mapped_record = Object.fromEntries(entries);
    return mapped_record;
};
